import script from "./VerPedido.vue?vue&type=script&setup=true&lang=js"
export * from "./VerPedido.vue?vue&type=script&setup=true&lang=js"

import "@/assets/plantilla/style.css?vue&type=style&index=0&id=7e64be41&scoped=true&lang=css"
import "./VerPedido.vue?vue&type=style&index=1&id=7e64be41&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e64be41"]])

export default __exports__